import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app/App";
import axios from 'axios';

axios.defaults.baseURL = process.env.WEBPAGE_PATH;

ReactDOM.render(<App />, document.getElementById("root"));
